import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFieldSectionComponent } from './components';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldModule } from '@jms/ui/ui.field';
import { CustomFieldTypePipe } from './custom.field.type.pipe';
import { KeyFilterModule } from 'primeng/keyfilter';
import { SwitchModule } from '@jms/ui/ui.switch';
import { LuxonCalendarModule } from '@workbuddy/ui/fields/luxon.calendar';
import { PipeModule } from '@jms/utils/util.pipes';
import { AutosizeModule } from '@jms/ui/ui.autosize';
import { CustomFieldValuePipe } from './custom.field.value.pipe';
import { CustomFieldIconPipe } from './custom.field.icon.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomFieldDrodownValuesPipe } from './custom.field.dropdown.values.pipe';
import { ContactPickerModule } from '@jms/ui/ui.pickers.contact';
import { UploadFieldComponent } from '@workbuddy/ui/fields/upload';
import { AddressComponent } from '@workbuddy/ui/fields/address';
import { LinkFieldComponent } from '@workbuddy/ui/fields/link';
import { LinkHrefPipe } from '@jms/utils/util.pipes';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FieldModule,
        KeyFilterModule,
        SwitchModule,
        LuxonCalendarModule,
        AutosizeModule,
        // AddressModule,
        AddressComponent,
        PipeModule,
        ContactPickerModule,
        NgSelectModule,
        UploadFieldComponent,
        LinkFieldComponent,
        LinkHrefPipe,
    ],
    declarations: [
        CustomFieldSectionComponent,
        CustomFieldTypePipe,
        CustomFieldIconPipe,
        CustomFieldValuePipe,
        CustomFieldDrodownValuesPipe
    ],
    providers: [
        CustomFieldTypePipe,
        CustomFieldValuePipe,
        CustomFieldIconPipe,
        CustomFieldDrodownValuesPipe
    ],
    exports: [
        CustomFieldSectionComponent,
        CustomFieldIconPipe,
        CustomFieldTypePipe,
        CustomFieldDrodownValuesPipe
    ],
})
export class CustomFieldsRuntimeModule { }
